import { render } from "./CreateSchedule.vue?vue&type=template&id=354b765a&scoped=true"
import script from "./CreateSchedule.vue?vue&type=script&lang=js"
export * from "./CreateSchedule.vue?vue&type=script&lang=js"

import "./CreateSchedule.vue?vue&type=style&index=0&id=354b765a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354b765a"]])

export default __exports__